import { completeUrl } from "@/utils/utils.js";

export const completeDirective = {
  mounted(el, binding, vnode) { // 元素插入到DOM树的时候，需要处理图片路径
    let endSrc = completeUrl(binding.value);
    el.src = endSrc;
  },
  updated(el, binding, vnode) { // 接口返回新数据的时候，也需要处理图片路径
    let endSrc = completeUrl(binding.value);
    el.src = endSrc;
  },
};
